export default "/images/LaetitiaRatier.jpg?dc5c53b8d2514025e95e78657115d514";